"use strict";

import angular from "angular";
import {
    customerUsers,
    nucontersUsers
} from "../../../../../utils/users-roles/users-roles";

angular.module("nucont.accounting.overview").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.overview.portfolio.companies.resume", {
            url: "/resumo?toastCertificate",
            params: {
                scheduleAutomation: { value: null, dynamic: true },
                toastCertificate: { value: null, dynamic: true }
            },
            views: {
                "submodules@nucont.accounting.overview.portfolio.companies": {
                    component: "accountingCompaniesResumeViewComponent"
                }
            }
        })
        .state("nucont.accounting.overview.portfolio.companies.data", {
            url: "/dados",
            params: { filterCompany: { value: null, dynamic: true } },
            views: {
                "submodules@nucont.accounting.overview.portfolio.companies": {
                    component: "accountingCompaniesDataViewComponent"
                }
            }
        })
        .state("nucont.accounting.overview.portfolio.companies.performance", {
            url: "/performance",
            params: {},
            data: {
                rolesGuard: [...nucontersUsers, ...customerUsers]
            },
            views: {
                "submodules@nucont.accounting.overview.portfolio.companies": {
                    component: "accountingCompaniesPerformanceViewComponent"
                }
            }
        })
        .state("nucont.accounting.overview.portfolio.companies.register", {
            url: "/registro",
            params: {},
            data: {
                rolesGuard: [...nucontersUsers, ...customerUsers]
            },
            views: {
                "submodules@nucont.accounting.overview.portfolio.companies": {
                    component: "accountingCompaniesRegisterViewComponent"
                }
            }
        })
        .state("nucont.accounting.overview.portfolio.companies.contacts", {
            url: "/contatos",
            params: {},
            views: {
                "submodules@nucont.accounting.overview.portfolio.companies": {
                    component: "accountingCompaniesContactsViewComponent"
                }
            }
        });
}
